/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/table-data/table-data');
const { dropMenu: dropMenuEvent } = require('components/config/event.json');
const tip = require('components/base/pop/tip');
const pop = require('components/base/pop/pop');

const ajaxHttp = require('appUtil/ajaxHttp');
const { apiPath } = require('appService/api');
const store = require('appVuex/store');
const calendar = require('components/common/data-calendar/data-calendar');
const { setBreadCrumb } = require('src/common/vuex/action/common');
const methMinxin = require('../../community/methMixin');
const template = require('./post-detail.tpl');
require('./post-detail.scss');
const LOGO = require('../../../../../assets/thumb.png')

const PostDetail = {
	mixins:[methMinxin],
	template,
	store,
	vuex: {
		actions: {
			setBreadCrumb,
		}
	},

	data() {
		return {
			thItems: ["评论时间","用户","评论内容", "回复对象","操作"],
			thItems: ["用户","评论内容", "回复对象","评论时间","操作"],
			infoUrl:apiPath.community.postDetail,
			chargerInfoUrl: apiPath.charge.commentDetail,
			postComment:apiPath.community.postComment,
			replyPost:apiPath.community.replyPost,
			replySpotPost:apiPath.charge.replySpotPost,

			getVestUrl: apiPath.common.getVest,
      		getLabelUrl:apiPath.common.getLabel,
			pageInitCt: 1,
			postId:this.$route.params.id,
			queryArgs:{'postId':this.$route.params.id},
			model:'comment',
			postType:this.$route.name,
			baseInfo:{
				postUser:'',
				groupLabel:'',
				likeAmount:0,
				commentAmount:0,
				headImg: ""
			},
			groupLabel:[{text:'请选择',value:"-1"}],
			comItems:[],
			ajaxend:true,

			commentId: '',
			commentIndex: '',
			commentFlag: '',
			replyComment : apiPath.community.replyComment,
			setStick: apiPath.community.setStick,
			isEditor: false,
			ajaxed:false,
			detailData: {
				postId: this.$route.params.id,
        contentDesc:'',
        detailImgs:[]
			},
			uploadImg: apiPath.common.uploadImg,
			serverSetAction: apiPath.community.addPost,
			editPost: apiPath.community.editPost
		}
	},
	ready(){
		//this.postId = this.$route.params.id;
		this.getInfo();
		this.postCommentList();
	},
	route:{
		data(tranistion){
        //   this.getVestFn();
          this.getLabelFn();
		}
	},
	methods: {
		getInfo(){
			let _url = this.postType == 'chager-postdetail' ? this.chargerInfoUrl : this.infoUrl;
			let args = this.postType == 'chager-postdetail' ? {'commentId': this.postId} : {'postId': this.postId };

			ajaxHttp(_url, {
			    type: "get",
			    data: args
			}).then((res)=> {
			  this.baseInfo = res.data;
			  this.baseInfo.headImg = this.baseInfo.headImg || LOGO;
		  }).catch((res)=> {
				  tip(res.error + _url);
			})
		},
		getLabelFn(){
			ajaxHttp(this.getLabelUrl)
			.then(res => {
				this.groupLabel = this.groupLabel.concat(res.data);
			})
		},
		getVestFn(val){
			if(val==-1 || val==""){return;}
			let proAr = [];
			//proAr.push({'value': -1, 'text': "请选择"});

			ajaxHttp(this.getVestUrl,{data:{'type':val}})
			.then(res => {
				res.data.forEach( item => {
					proAr.push({'value':item.id, 'text': item.nickName});
				})
				this.comItems = proAr;
				// this.$refs.userlist.val("-1");
			});
		},
		postCommentList(){
			this.$refs.tableData.query({
				"postId":this.postId
			}).fetch();
		},
		cancelEdit() {   //取消编辑帖子
			this.isEditor = false;
		},
		editDetail() {   //编辑帖子
			if (this.isEditor){  //保存
				if (this.ajaxed) return;
				this.$refs.formArea.setAction(this.editPost).submit();
				return;
			}

			//将当前数据赋值到编辑器中
			let { content, postImgs,  } = this.baseInfo, newImgs = [];
			this.detailData.contentDesc = content;
			if (postImgs && postImgs.length){
				postImgs.forEach((item, index) => {
					let obj = {
						url: item.imageUrl,
						id: item.imageId
					}
					newImgs.push(obj);
				})
			}
			this.detailData.detailImgs = newImgs;
			this.isEditor = true;
		},
		beforeSubmit(par){   //增加参数 及 组装图片数据: {id, isNew}  isNew:  是否为新增图片 1-是  0-否
			let { detailImgs, postId } = this.detailData, newImgs = [], isnull = true;

			if (!detailImgs.length){   //detailImgs: 旧图只有id/url字段， 新加的图有width和height字段
				let { postImgs } = par;
				if (postImgs && postImgs.length){   //如果之前没有图片，图片都是后来加的
					postImgs.forEach((item, index) => {
						detailImgs.push({ id: item, url: "" });
					})
					isnull = false;
				}
			}

			newImgs = detailImgs.map((item, index) => {   //组装新的图片数组
				let obj = { id: item.id };
				obj.isNew = !isnull || Object.keys(item).length > 2 ? 1 : 0;
				return obj;
			})

			par.postImgs = newImgs;
			par.postId = postId;

      this.ajaxed = true;
    },
		success(rtn){
      if(rtn.code==2){
        this.loginLose();
        return;
			}
			
      if(rtn.code==0){
				tip("修改成功");
				this.ajaxed = false;
				this.isEditor = false;
				this.getInfo();

			}else{
				this.ajaxed = false;
				tip(rtn.error || '系统繁忙,请稍候在试')
			}
		},
		loginLose(){
			tip('登录信息过期');
			window.localStorage.removeItem('appBackToken');
			AB.TOKEN = null;

			let _hash = window.location.hash, _idx =_hash.indexOf("/");
			_hash = _hash.substring(_idx);
			if(_hash!="/login" && _hash.indexOf('/page') !=-1){
				sessionStorage.setItem("cbkURL",_hash);
			}
			setTimeout(()=>{
				this.$route.router.go({ path: '/login' });
			}, 500);
		},
		stickFn(val){ //置顶
				let that = this;
        let _val = val==0? 1: 0;
        let args = {
          'postId':this.postId,
          'isTop': _val
        }

        ajaxHttp(this.setStick, {
            type: "post",
            data: args
        }).then((res)=> {
						that.baseInfo.stick = _val;
        }).catch((res)=> {
            tip(res.message);
        })
		},
		setEssenceFn(val){ //精华
        let that = this;
        let _val = val==0? 1: 0;
        let args = {
          'postId':this.postId,
          'isBest': _val
        }

        ajaxHttp(this.setEssence, {
            type: "post",
            data: args
        }).then((res)=> {
           this.baseInfo = Object.assign({},this.baseInfo,{'elite':_val});
        }).catch((res)=> {
            tip(res.message);
        })
      },
		searchData() {
			this.searchVal = this.$refs.userInputbox? this.$refs.userInputbox.val(): "";
			this.$refs.tableData.query({
			}).fetch();
		},
		getQueryString(name) {
			if(typeof window.location.hash.split("?")[1] === 'undefined'){
				return '';
			}
			let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
			let r = window.location.hash.split("?")[1].match(reg);
			if (r != null) return unescape(r[2]); return null;
		},
		senderFn(){
			console.log(this.commentFlag)
			//replyPost回帖
			let that = this;

			if(!that.ajaxend){
				return;
			}

			let _userId = this.$refs.userlist.value;
			if(!this.$refs.commentCont.value){
				tip('请输入回复内容');
				return;
			}
			if(_userId==-1 || _userId == ""){
				tip('请选择回帖账号');
				return;
			}

			if(this.commentFlag == 1) {
				//回复帖子
				let args = {
				'postId':this.postId,
				'commentContent': this.$refs.commentCont.value,
				'observerIdent':_userId
				}

				let _url = this.postType == 'chager-postdetail' ? this.replySpotPost : this.replyPost;
				that.ajaxend = false;
				ajaxHttp(_url, {
					type: "post",
					data: args
				}).then((res)=> {
						that.ajaxend = true;

					tip("回帖成功");
					this.$refs.popssend.hide();
					this.postCommentList();
					that.baseInfo.commentAmount++;
				}).catch((res)=> {
						that.ajaxend = true;
					tip(res.message);
				})

			} else if(this.commentFlag == 2) {
				//回复评论
				let args1 = {
					'postId':this.postId,
					'commentContent': this.$refs.commentCont.value,
					'observerIdent':_userId,
					"commentId": this.commentId
				}
				let _url1 = this.replyComment;
				that.ajaxend = false;
				ajaxHttp(_url1, {
					type: "post",
					data: args1
				}).then((res)=> {
						that.ajaxend = true;
					tip("回帖成功");
					this.$refs.popssend.hide();
					this.postCommentList();
					that.baseInfo.commentAmount++;
				}).catch((res)=> {
						that.ajaxend = true;
					tip(res.message);
				})
			}
		},

		showPostPop(commentId, index, flag) {
			this.$refs.commentCont.val("");
			this.$refs.grouplabel.val("-1");
			this.$refs.userlist.val("-1");

			this.commentFlag = flag;
			if(index >= 0) {
				this.commentId = commentId;
				this.commentIndex = index;
			}
			this.$refs.popssend.show();
		},
		cancel(){
			this.$refs.popssend.hide();
			this.$refs.popsdelete.hide();
		}
	},
	events:{
		[dropMenuEvent.menu.change](opt){
			let qName = opt.queryName;
			if(qName =='groupLabel'){
				// console.log(opt.optionItem.value);
				let _val = opt.optionItem.value;
				this.$refs.userlist.value = -1;
				this.$refs.userlist.text = "请选择";
				this.getVestFn(_val);
				return;
			}
		}
	},
	filters:{
		limitStr: function(str, leng) {
			let len = (typeof leng =='undefined')? 32 : leng;
				if(str.length*2 <= len) {
				return str;
				}
			let strlen = 0, s = "";
			for(let i = 0;i < str.length; i++) {
			s = s + str.charAt(i);
			if (str.charCodeAt(i) > 255) {
			strlen = strlen + 2;
			if(strlen >= len){
				return s.substring(0,s.length-1) + "...";
			}
			} else {
			strlen = strlen + 1;
			if(strlen >= len){
				return s.substring(0,s.length-2) + "...";
			}
			}
			}
			return s;
			}
	},
	components:{
		pop
	}
}

module.exports = PostDetail;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/community/common-post/post-detail/post-detail.js